import React from 'react';

const FlexTable = ({children}) => {
    return (
        <div className="flex-table">
            {children}
        </div>
    );
};

export default FlexTable;
